<script setup>
import {
    onMounted, ref, inject, defineExpose
    //  nextTick 
} from 'vue';
import { useRoute } from 'vue-router';
import { getProductDetail, getFileUrl, getProductDetailV3 } from "@/service/index"
import { getLangValue, } from "@/utils/common"; //获取后端语言
import i18n from "@/i18n"
// import { showMessage } from "@/utils/hooks/message"
import moment from "moment"
// import { sankey_v3 } from "@/service"
// import { sankey2Chart } from "@/utils/chart.js"
const route = useRoute();
const productInfo = inject('productInfo') // 产品信息
const product_pic = ref('') // 产品图片
const product_trademark_pic = ref('') // 产品商标图片
// const currentLang = ref(computed(()=> i18n.global.locale) ) // 当前语言
// const lastTime = ref('') // 上次获取时间
const showWatermark = ref(false) // 是否显示水印logo
const certificationCompany = ref({
    name: '',
    logo: '',
}) // 审核该产品认证公司信息
const getProductInfo = async () => {
    // 获取详情信息
    // is_public=1 代表是公开产品数据库来的 需要吊公开产品的详情  反之则不需要
    // 这里打开的页面是二维码的详情页  浏览量需要+1
    let params = {
        from_qrcode: 1
    }
    const resp = route.query.is_public == 1 ? await getProductDetailV3(route.params.id, params) : await getProductDetail(route.params.id, params)
    if (resp.code == 0) {
        productInfo.value = resp.payload;
        const { product_info } = resp.payload
        const basiInofo = product_info.children.find(item => item.key == 'product_info_base_info')
        productInfo.value.name = getValueByKey(basiInofo.children, 'product_info_base_info_product_name')
        productInfo.value.batchValue = getValueByKey(basiInofo.children, 'product_info_base_info_batch_size')
        productInfo.value.size = getValueByKey(basiInofo.children, 'product_info_base_info_size')
        productInfo.value.color = getValueByKey(basiInofo.children, 'product_info_base_info_color')
        productInfo.value.publishTime = resp.payload.create_time
        productInfo.value.product_washing_instructions_name = i18n.global.locale == 'en' ? getValueByKey(product_info.children, 'product_washing_instructions', 'name_en') : getValueByKey(product_info.children, 'product_washing_instructions', 'name')
        productInfo.value.product_washing_instructions_value = getValueByKey(product_info.children, 'product_washing_instructions',)
        productInfo.value.product_recycling_discarding_instructions_name = i18n.global.locale == 'en' ? getValueByKey(product_info.children, 'product_recycling_discarding_instructions', 'name_en') : getValueByKey(product_info.children, 'product_recycling_discarding_instructions', 'name')
        productInfo.value.product_recycling_discarding_instructions_value = getValueByKey(product_info.children, 'product_recycling_discarding_instructions',)
        // 获取图片
        let product_pic_list = getValueByKey(product_info.children, 'product_info_product_picture') || []
        let product_trademark_list = getValueByKey(product_info.children, 'product_trademark') || []
        // 获取产品图片、产品商标
        let imgstr = [];
        if (product_pic_list.length || product_trademark_list.length) {
            imgstr.push(product_pic_list[0])
        }
        if (product_trademark_list.length) {
            imgstr.push(product_trademark_list[0])
        }
        // 获取文件信息
        if (imgstr.length) {
            getFileUrl({ attachments: imgstr.join(',') }).then(resp => {
                if (resp) {
                    // 获取信息
                    if (product_pic_list.length) {
                        let obj = resp.payload.find(item => item.id === product_pic_list[0])
                        product_pic.value = obj ? obj.url : ''
                    }
                    if (product_trademark_list.length) {
                        let obj = resp.payload.find(item => item.id === product_trademark_list[0])
                        product_trademark_pic.value = obj ? obj.url : ''
                    }
                }
            })
        } else {
            // showMessage('danger', resp.message)
        }
        // 获取信息
        checkProductAndSetLogo(resp.payload);
    }
}
const getValueByKey = (objData, key, valueKey = 'value') => {
    // 通过key来获取  不通过index 顺序修改了会报错
    if (objData) {
        let obj = objData.find(item => item.key == key)
        return obj && obj[valueKey] != null ? obj[valueKey] : '-'
    }
    return '-'
}

const getFid = () => {
    // 获取fid
    let fid = ``
    if (productInfo.value?.production_line) {
        const { name, province, city, address1 } = productInfo.value?.production_line?.place_of_origin
        let fid = `FBD-${productInfo.value?.organization.certificate_number}-${(name + province + city + address1).replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, '')}`
        return fid
    }

    return fid
}

const getStructure = () => {
    // 获取结构
    let structure = []
    // 获取数据
    const { product_info: product_info1 } = productInfo.value
    if (product_info1) {
        // console.log(product_info1.children);
        const structureList = getValueByKey(product_info1.children, 'product_info_base_info_structure', 'children')
        // console.log(structureList);
        for (const item in structureList) {
            const { extra } = structureList[item]
            // console.log(extra);
            let data = extra ? extra.data : []
            for (const item1 in data) {
                const { layer, name, proportion } = data[item1]
                let layer1 = ''
                // console.log(productInfo.value.has_dat);
                if (productInfo.value.has_dat && layer) {
                    layer1 = layer == "lining" ? getLangValue('attribute', 'lining') : layer == "shell" ? getLangValue('attribute', 'shell') : getLangValue('attribute', 'interlayer');
                }
                structure.push(`<div>${layer1 ? layer1 + ':' : ''} ${proportion}%${name}</div>`)
            }
        }
    }

    return structure.length ? structure.join('</br>') : '-'
}
// const getchartData = async () => {
//     // 获取图表数据
//     let params = {
//         table_name: productInfo.value.organization?.table_name,
//         database_id: productInfo.value.id,
//         category_id: 1,
//         type: 0,
//     }
//     const reps = await sankey_v3(params)
//     if (reps.code == 1) {
//         showMessage('danger', reps.message)
//         return
//     }
//     if (reps.payload.nodes.length && reps.payload.links.length) {
//         nextTick(() => {
//             makeCharts(reps.payload,)
//         })
//     }else{
//         document.getElementById('snakey_chart1').innerHTML = getLangValue('base', 'no_data') 
//     }
// }
// const makeCharts = (data,) => {
//     // 开始画桑基图
//     let options = {
//         chartDom: document.getElementById('snakey_chart1'),
//         data: data,
//         nodeDataList: data.nodes
//     };
//     sankey2Chart(options, true, 'normal', 'value',);
// }
const getPublishTime = () => {
    // 检查产品是否公开  以及审核状态 
    // 当产品数据公开状态是：不公开、供应链公开、完全公开-未审核/未通过时，上架时间显示：-；完全公开且审核通过的才显示上架时间
    let publicType = getValueByKey(productInfo.value?.template_info?.children, 'template_info_public_type')
    if (publicType == 2 && (productInfo.value?.status == 1 || productInfo.value?.status == 2) && productInfo.value?.sub_status === 0) {
        return moment(productInfo.value.publishTime).locale("en").format("DD MMMM,YYYY")
    }
    return '-'
}

// const isWithin3Seconds = (startTime, endTime) => {
//   return Math.abs(endTime - startTime) < 3000;
// };

const checkProductAndSetLogo = async (data) => {
    // 检测产品装填是否认证通过
    // 他如果是认证通过就显示水印logo
    // 获取信息
    if (data.certification_user) {
        // 获取图片
        if (data.certification_user.company_logo) {
            console.log(111);
            const resp = await getFileUrl({ attachments: data.certification_user.company_logo })
            certificationCompany.value = {
                name: data.certification_user.name,
                logo: resp.payload[0] ? resp.payload[0].url : '',
            }
            showWatermark.value = true
        } else {
            certificationCompany.value = {
                name: data.certification_user.name,
                logo: '',
            }
            showWatermark.value = false
        }

    }
}

onMounted(() => {
    // getProductInfo();
})

// watch(currentLang, (newLang) => {
//     // 监听语言变化
//     // 判断时间
//     console.log(lastTime.value);
//     console.log( Date.now());
//     if(lastTime.value &&  isWithin3Seconds(lastTime.value, Date.now())) {
//         return
//     }
//     if(newLang == route.query.lang) {
//         lastTime.value = Date.now()
//         getProductInfo();
//     }
// }, { immediate: true })

defineExpose({
    getProductInfo,
})
</script>
<template>
    <div>
        <div class="title-1 py-3 ">
            {{ getLangValue('product-template', 'trademark_product') }}
        </div>
        <div class="d-flex  px-4 justify-content-between">
            <div style="width: 120px;">
                <img :src="product_trademark_pic" style="width: 117px; height: 128px;">
                <div style="text-align: center; word-break: break-all;">
                    <!-- {{ productInfo.name }} -->
                    <span class="color1"> {{ getLangValue('product-template', 'product_trademark') }}</span>
                </div>
            </div>
            <div style="width: 120px;">
                <img :src="product_pic" style="width: 117px; height: 128px;">
                <div style="text-align: center; word-break: break-all;" class="color1">{{ productInfo.name }}</div>
            </div>
        </div>
        <div class="title-1 py-3 ">{{ getLangValue('dashboard', 'digital_assport') }}</div>
        <div class=" align-items-center px-1" style="position: relative;">
            <div class="my-1 info">
                {{ getLangValue('attribute', 'supplier') }}：{{ productInfo.organization?.company_name }}
            </div>
            <div class="my-1 info">{{ getLangValue('product-template', 'origin') }}：{{
                productInfo.production_line?.place_of_origin?.name
                }}
            </div>
            <div class="my-1 info">
                {{ getLangValue('product-template', 'color') }}：{{ productInfo.color }}
            </div>
            <div class="my-1 info">
                {{ getLangValue('product-template', 'size') }}：{{ productInfo.size }}
            </div>
            <div class="my-1 info">
                {{ getLangValue('product-template', 'batchValue') }} ：{{ productInfo.batchValue }}
            </div>

            <div class="my-1 info">
                {{ getLangValue('dashboard', 'listingTime') }}：{{ getPublishTime() }}
            </div>

            <div class="my-1 info">
                HScode：{{
                    route.query.lang == 'en' ? productInfo.production_line?.database_template.hscode?.title_en :
                        productInfo.production_line?.database_template.hscode?.title }}
            </div>
            <div class="my-1 info">
                {{ getLangValue('dashboard.hScodedescription') }}：{{
                    route.query.lang == 'en' ? productInfo.production_line?.database_template.hscode?.description_en :
                        productInfo.production_line?.database_template.hscode?.description
                }}
            </div>
            <div class="my-1 info">
                {{getLangValue('product-management', "code_oid")}}：{{ productInfo.organization?.oid }}
            </div>
            <div class="my-1 info">
                {{getLangValue('product-management', "plid")}}：{{ productInfo.production_line?.plid }}
            </div>
            <div class="my-1 info">
                {{getLangValue('product-management', "pid")}}：{{ productInfo?.pid }}
            </div>

            <div class="my-1 info">
                {{getLangValue('product-management', "code_pid_gtin")}}：{{ `FBD` + productInfo.pid }}
            </div>
            <div class="my-1 info">
                {{getLangValue('product-management', "eu_pigital_product _passport_registry_id")}}：<span :class="productInfo.eu_registry_id ? 'text-primary' : 'text-secondary'">{{productInfo.eu_registry_id || getLangValue('product-management', "unregistered_eu_digital_passport") }}</span>
            </div>
            <div class="my-1 info">
                {{getLangValue('product-management', "eu_pigital_product _passport_registry_date")}}：<span class="">{{productInfo.eu_registry_date || '-' }}</span>
            </div>
            <div class="my-1 info">
                {{getLangValue('product-management', "eu_pigital_product _passport_update_date")}}：<span class="">{{productInfo.eu_registry_update_date || '-' }}</span>
            </div>
            <div class="my-1 info">
                {{getLangValue('product-management', "fid")}}：{{ getFid() }}
            </div>
            <div class="my-1 info">
                {{ getLangValue('dashboard', 'official_website') }}：<a href="http://www.FBD.com" target="_blank"
                    style="color:rgba(45, 132, 218, 1); text-decoration: underline !important;">www.FBD.com</a>
            </div>
            <!-- 新增一个水印logo -->
            <!-- <div class="my-1 watermark p-2" v-if="showWatermark">
                <div class="w-100 h-100 d-flex flex-column align-items-center justify-content-center">
                    <img :src="certificationCompany.logo" v-if="certificationCompany.logo"
                        style="width: 80px; height: 80px;">
                </div>
            </div> -->
            <div class="stamp1 " v-if="productInfo.status == 2 && productInfo.sub_status === 0"
                :title="certificationCompany.name">
                <!-- 显示logo -->
                <div class=" watermark w-100 h-100" v-if="showWatermark">
                    <img :src="certificationCompany.logo" style="width: 60px; height: 60px;">
                    <div class="text" style="font-size: 13px;">
                                                {{ getLangValue("business-product", 'certificationPassed') }}</div>
                </div>
                <!-- 显示原来的 -->
                <template v-else>
                    <div class="inner-circle"></div>
                    <div class="text" style="font-size: 13px;">
                        {{ getLangValue("business-product", 'certificationPassed') }}</div>
                    <div class="arc"></div>
                    <div class="arc arc-bottom"></div>
                    <div class="stars">
                        <div class="star star-1"></div>
                        <div class="star star-2"></div>
                        <div class="star star-3"></div>
                        <div class="star star-4"></div>
                        <div class="star star-5"></div>
                        <div class="star star-6"></div>
                        <div class="star star-7"></div>
                        <div class="star star-8"></div>
                    </div>
                </template>
            </div>
        </div>
        <div class="title-1 py-3 ">
            {{ getLangValue('dashboard', 'material_composition_and_content') }}
            <!-- 原料成分及含量 -->
        </div>
        <div class="align-items-center px-2 justify-content-between info" v-html="getStructure()">
        </div>
        <div class="title-1 py-3 ">
            <!-- {{ getLangValue('product-template', 'productInfo') }} -->
            {{ productInfo?.product_washing_instructions_name }}
        </div>
        <div class="align-items-center px-2 justify-content-between info"
            v-html="productInfo?.product_washing_instructions_value">
        </div>
        <div class="title-1 py-3 ">
            <!-- {{ getLangValue('product-template', 'productInfo') }} -->
            {{ productInfo?.product_recycling_discarding_instructions_name }}
        </div>
        <div class="align-items-center px-2 justify-content-between info"
            v-html="productInfo?.product_recycling_discarding_instructions_value">
        </div>
        <!-- <div class="title-1 py-3 ">{{ getLangValue('dashboard', 'ingredient_traceability') }}</div>
        <div style="width: 600px; overflow: auto;">
            <div id="snakey_chart1" style="width: 100%; height: 300px;"></div>
        </div> -->
    </div>
</template>
<style scoped>
.title-1 {
    color: rgba(73, 80, 87, 1);
    font-size: 0.9rem;
    text-align: left;
    font-weight: bold;
    border-top: 1px solid #0000001A;

    &:first-child {
        border-top: none;
    }
}

.color1 {
    color: rgba(33, 37, 41, 1)
}

.info {
    word-break: break-all;
    color: rgba(33, 37, 41, 1);
    z-index: 1;
}

.watermark {
    /* 设置透明度，别太亮 */
    pointer-events: none;
    /* 不影响交互 */
    z-index: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
        transform: rotate(-30deg);
    }
    .text {
        transform: rotate(-40deg);
        z-index: 3;
        opacity: 0.9;
    }
}

.stamp1 {
    width: 100px;
    height: 100px;
    border: 2px solid #8dc8bf;
    border-radius: 50%;
    position: relative;
    background-color: #fff;
    position: absolute;
    right: 20px;
    top: 0;
    opacity: 0.45;
    &:hover {
       background-color: #313a56;
        opacity: 1;
    }

    .inner-circle {
        width: 84px;
        height: 84px;
        border: 1px solid #8dc8bf;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(-15deg);
        font-size: 8px;
        color: #8dc8bf;
        font-weight: bold;
        font-family: Arial, sans-serif;
        width: 60px;
        text-align: center;
    }

    .arc {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 60px;
        height: 60px;
        border: 1px solid transparent;
        border-top-color: #8dc8bf;
        border-radius: 50%;
        transform: translate(-50%, -50%);
    }

    .arc-bottom {
        transform: translate(-50%, -50%) rotate(180deg);
    }

    .stars {
        position: absolute;
        width: 100px;
        height: 100px;
        top: 0;
        left: 0;
    }

    .star {
        position: absolute;
        width: 10px;
        height: 10px;
        background-color: #8dc8bf;
        clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
    }

    /* 星星沿弧线的排列 */
    .star-1 {
        top: 8px;
        left: 50%;
        transform: translateX(-50%) rotate(0deg);
    }

    .star-2 {
        top: 18px;
        left: 70px;
        transform: rotate(45deg);
    }

    .star-3 {
        top: 50%;
        left: 80px;
        transform: translateY(-50%) rotate(90deg);
    }

    .star-4 {
        bottom: 20px;
        left: 70px;
        transform: rotate(135deg);
    }

    .star-5 {
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%) rotate(180deg);
    }

    .star-6 {
        bottom: 20px;
        right: 70px;
        transform: rotate(225deg);
    }

    .star-7 {
        top: 40%;
        left: 10px;
        transform: rotate(200deg);
    }

    .star-8 {
        top: 15px;
        right: 70px;
        transform: rotate(315deg);
    }
}
</style>